import {Directive} from '@angular/core';

@Directive({
	selector: 'label[carooInputLabel]'
})
export class InputLabelDirective {
}
